'use strict';

require('../../style/index.less');

require('./index.less');

require('../../select/style');

require('../../input/style');


/*****************
 ** WEBPACK FOOTER
 ** ./components/pagination/style/index.js
 ** module id = 63
 ** module chunks = 0
 **/